<template>
  <div :data-testid="dataTestid">
    <TsHeroBanner :backgroundImage="props.backgroundImage" :title="props.title"
      :data-testid="dataTestid + '-hero-banner'" />
    <slot>
      <TsTypography appendClass="my-4" :data-testid="dataTestid + '-banner-text'">{{ props.caption }}</TsTypography>
      <ul class="ml-4" :data-testid="dataTestid + '-list-ul'">
        <li v-for="item in props.list" :key="item.id" :data-testid="dataTestid + `-list-li${item.id}`">{{ item.text }}
        </li>
      </ul>
    </slot>
  </div>
</template>

<script setup lang="ts">


const TsHeroBanner = defineAsyncComponent(
    () => import('~/components/organisms/TsHeroBanner.vue')
);

type Props = {
  backgroundImage?: string,
  title?: string,
  caption?: string,
  list?: object[],
  dataTestid?: string;
}

const props = withDefaults(defineProps<Props>(), {
  backgroundImage: '/images/About-us-banner.webp',
  title: 'Lorem ipsum dolor sit aconsectetur adipiscing elit, sed do eiusmod'
})

</script>
